/**
 * Validates the data passed in to ensure it is valid for a call to the API.
 *
 * @param {String} args.lineupSlug - the lineup id to be validated against
 * @param {String} args.subjectsSet
 * @param {String} args.tags
 *
 * @returns {boolean} true if all data is valid, false otherwise.
 */
export function validateApiData(args) {
    // Do not fetch when there's missing lineupSlug.
    // NOTE: Ideally categorySlug should also exist for page call, otherwise there will be no tracking metadata.
    // Responsibility will be diverted to the content developers
    return !!args.lineupSlug || !!args.subjectsSet || !!args.tags;
}

export function insertAd(items, position = 0) {
    // Insert the add in the middle (after confirming the content item the ad with be inserted with exists)
    if (items.length > position) {
        items[position].insertAd = true;
    }

    return items;
}
